<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
    <div class="comm_scr_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_TASK_TYPE')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <cmp-task-id-select
            ref="taskIdSelect"
            :pageId="this.$options.name"
            :default1LevelOption="'all'"
            :default2LevelOption="'all'"
            :default3LevelOption="'all'"
            @select-changed="onChangeBizCodes"
          />
        </div>
                <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_SEARCH_COND')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-code-select
            ref="condType"
            :selected="selectedValues.COD_ROLE_SRCH_COND"
            codeId="COD_ROLE_SRCH_COND"
            :defaultOption="'all'"
            class="width50"
            @loaded="onCondTypeLoaded"
          />
          <div class="comp_spacing" />
          <sui-text-field
            v-model="condContent"
            maxlength="50"
            @keyup.enter="onSearch"
            @keyup="onKeyUpInput"
          />
        </div>
      </div>

      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_Reset"
          @click="onReset"
        >
          {{ $t("MSG_BTN_RESET") }}
        </sui-button>
        <sui-button
          v-permission:read="'PGE_CMA_00002'"
          type="button"
          class="comm_btn_Scr"
          @click="onSearch"
        >
          {{ $t("MSG_BTN_SEARCH") }}
        </sui-button>
      </div>
    </div>
    <div class="mrB30" />
    <div class="mrB10" />
    <sui-grid
      ref="grdList"
      :showCountControl="true"
      :showDisplayCountControl="false"
      :multiselect="false"
      :sortable="false"
      :filterable="false"
      :columns="gridColumns"
      :columnsautoresize="true"
      width="100%"
      :dataset="'dsData'"
      :initialPagesize="5"
    />
    </sui-page-contents>
    <sui-page-footer>
    <div class="comm_btn_wrap">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onSelect"
      >
        {{ $t('MSG_BTN_SELT') }}
      </sui-button>
    </div>
   </sui-page-footer>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
export default {
  name: 'PGE_CMA_00002', // eslint-disable-line vue/name-property-casing
  props: {
    closePagePopup: {
      type: Function,
      required: true,
    },
    pageInitialData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      searchFieldOldText: '',
      selectedGridRowData: {},
      oldRowIndex: -1,
      condTypeKey: '',
      selectedValues: {
        // form input 값등이 저장될 변수
        COD_ROLE_SRCH_COND: { key: '', label: '' },
      },
      condContent: '',
      selectedBizCode: [],
      localdata: [],
      gridColumns: [
        {
          text: this.$t('MSG_TXT_ROLE_ID'),
          datafield: 'roleId',
          width: 150,
        },
        {
          text: this.$t('MSG_TXT_ROLE_NAME'),
          datafield: 'roleName',
        },
        {
          text: this.$t('MSG_TXT_ROLE_ALIAS'),
          datafield: 'roleNickName',
          width: 150,
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
          width: 250,
        },
      ],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata',
    datafields: [
//      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'roleId', type: 'string', map: 'roleId' },
      { name: 'roleName', type: 'string', map: 'roleName' },
      { name: 'roleNickName', type: 'string', map: 'roleNickName' },
      { name: 'taskName', type: 'string', map: 'taskName' },
    ],
  }],
  mounted() {
    this.dsData.$on(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
    if (this.dsData) {
      this.dsData.$off(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    }
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onClose() {
      console.log('onConfirm');
    },
    onCondTypeLoaded(optionsList) {
      this.condTypeKey = optionsList[0].key;
    },
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;
      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onReset() {
      this.$refs.condType.reset();
      this.selectedValues.COD_ROLE_SRCH_COND.key = this.condTypeKey;
      this.condContent = '';
      this.$refs.taskIdSelect.reset();
    },
    onSearch() {
      // 구분 코드
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

      const condTypeCode = this.selectedValues.COD_ROLE_SRCH_COND.key;
      const queryParams = {
        taskId: taskId || '',
        searchCond: condTypeCode || '',
        searchWord: this.condContent || '',
      };

      http.request(this.$options.name, 'DTS_CMA_00001', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          this.dsData.setRawData(res.data);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onSelect() {
      this.closePagePopup(this.selectedGridRowData);
    },
    onCancel() {
      this.closePagePopup('');
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onSelectGrid(oldSelections, newSelections) {
      console.log(newSelections);
      if (!this.dsData.getSelectedIndexes().length) {
        return;
      }

      if (oldSelections.newSelections[0] > -1) {
        if (this.oldRowIndex > -1) {
          const checkFalse = [];
          checkFalse.push('false');
          this.dsData.setData(this.oldRowIndex, 'check', checkFalse);
        }

        const rowIndex = oldSelections.newSelections[0];
        this.oldRowIndex = rowIndex;
        const checkTrue = [];
        checkTrue.push('true');
        this.dsData.setData(rowIndex, 'check', checkTrue);

        this.selectedGridRowData = this.dsData.getSelectedRow();
      }
    },
  },
};
</script>
<style scoped>
</style>
